import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';
import { useForBindingId } from '../../../forBinding';

export function useDeleteAdviceCorrection() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();
	return useMutation<void, Error, string>({
		mutationFn: async (id: string) => {
			try {
				await api.delete(`/advices/planting/delete/${id}`, {
					params: { forBinding },
				});
			} catch (error) {
				throw toApiError(error, 'Erro ao deletar recomendação de correção');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['correction'] });
		},
		onError: (error) =>
			console.error(
				'Erro ao deletar correção:',
				getApiErrorMessage(error, 'Erro ao deletar recomendação de correção')
			),
	});
}
